/**
 * @generated SignedSource<<6601cf6f884fbb01e79f24926a375ef9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FollowTopicInput = {
  topicSlug: string;
};
export type DiscoverPageFollowMutation$variables = {
  input: FollowTopicInput;
};
export type DiscoverPageFollowMutation$data = {
  readonly followTopic: {
    readonly topic: {
      readonly followerCount: number;
      readonly id: string;
      readonly isFollowedByViewer: boolean | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type DiscoverPageFollowMutation = {
  response: DiscoverPageFollowMutation$data;
  variables: DiscoverPageFollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FollowTopicPayload",
    "kind": "LinkedField",
    "name": "followTopic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscoverPageFollowMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscoverPageFollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e12387bed5eca24d12ae9fd461a8674",
    "id": null,
    "metadata": {},
    "name": "DiscoverPageFollowMutation",
    "operationKind": "mutation",
    "text": "mutation DiscoverPageFollowMutation(\n  $input: FollowTopicInput!\n) {\n  followTopic(input: $input) {\n    topic {\n      id\n      isFollowedByViewer\n      followerCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e774d8c13d4ebc882e8318516210a75";

export default node;
